import m from 'mithril'
import Location from '../shared/location.js'
var WeatherData = {
    key: "de83ed9a5102075f55058d01d98ee118",
    response: undefined,
    data: undefined,
    reload: function() {
      console.info("Reloading location")
      localStorage.removeItem('weatherData')
      return WeatherData.fetch()
    },
    fetch: function() {
      var response = JSON.parse(localStorage.getItem('weatherData'))
      var downloadInterval = 15 * 60 * 1000
      if (response) {
        if (!response.timestamp || +new Date() - response.timestamp > downloadInterval) {
          response = undefined;
        } 
  
        WeatherData.response = response;
        if (response) {
          document.redraw();
          console.info("Using Cached Weather", response)
          return Promise.resolve(response);
        }
      }

      var loc = Location;
      document.setStatus("Downloading weather for " + loc.name, 3000)
      var url = "https://api.darksky.net/forecast/" + WeatherData.key + "/" + loc.lat + "," + loc.long;
      url = "https://cors-anywhere.herokuapp.com/" + url

      return m.request({
          method: "GET",
          url: url,
      })
      .then(function(response) {
        document.setStatus("Got new weather data for " + loc.name)
        response.timestamp = +new Date();
        localStorage.setItem('weatherData', JSON.stringify(response));
        WeatherData.response = response
        return response;
      })
      .catch(function(err) {
        console.log(err)
      })
    
    }
  }

  module.exports = WeatherData